import * as ReactGA from 'react-ga';

export const initGA = (trackingID: string) => {
  const options = {
    titleCase: false,
    debug: true
  };
  if (process.env.NODE_ENV === 'production') {
    options.debug = false;
  }
  ReactGA.initialize(trackingID, options);
};

export const PageView = (title?: string | undefined) => {
  ReactGA.pageview(window.location.pathname + window.location.search, [], title);
};

export const DownloadEvent = (label: string) => {
  ReactGA.event({
    category: 'Material',
    action: 'Download',
    label
  });
};

export const PreviewEvent = (label: string) => {
  ReactGA.event({
    category: 'Material',
    action: 'Preview',
    label
  });
};



// WEBPACK FOOTER //
// ./src/components/GoogleAnalytics/GoogleAnalytics.tsx